import React, { useState } from "react";
import { useSpots } from "../hooks/spots";
import useDocumentTitle from "../hooks/useDocumentTitle";

import { Row, Col, Button, Spinner, Modal } from "reactstrap";
import { Link } from "react-router-dom";
import SpotListItem from "./SpotListItem";
import SpotEditForm from "./SpotForm/SpotEditForm";

const Spots = () => {
  useDocumentTitle("Spots");

  const [modal, setModal] = useState(false);
  const [spotToEdit, setSpotToEdit] = useState({});

  const { data: spots, isLoading } = useSpots();

  const toggleModal = () => setModal((prevState) => !prevState);

  const fillEditModal = (spotId) => {
    setSpotToEdit(spots.find((s) => s.id === spotId));
    setModal(true);
  };

  return (
    <>
      <Row>
        <Col xs={12} md={{ size: 6, offset: 3 }}>
          <Row className="mt-2">
            <Col xs={7} md={9}>
              <h2>Spots: </h2>
            </Col>
            <Col xs={5} md={3}>
              <Button
                color="primary"
                className="float-right"
                tag={Link}
                to="/createspot"
              >
                Add a Spot
              </Button>
            </Col>
          </Row>
          <Row>
            {isLoading ? (
              <Spinner className="global-spinner" />
            ) : (
              spots &&
              spots.map((s) => (
                <Col key={s.id} xs={12} className="mb-1">
                  <SpotListItem spot={s} openEditModal={fillEditModal} />
                </Col>
              ))
            )}
          </Row>
        </Col>
      </Row>
      <Modal
        id="edit-modal"
        className="modal-fullscreen"
        isOpen={modal}
        toggle={toggleModal}
        size="lg"
        modalTransition={{ timeout: 50 }}
      >
        <SpotEditForm spot={spotToEdit} onCancel={toggleModal} />
      </Modal>
    </>
  );
};

export default Spots;
